import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import {
  CREATE_VERSION_LOCALE_MUTATION,
  READ_VERSION_LANGUAGES_QUERY_NAME,
} from "graphqlQueries/versions";

import { addLocaleValidator } from "validators/addLocaleValidator";

const fieldsWithPlaceForError = ["locale"];

const AddLocaleDialog = (props) => {
  const { version } = props;

  const initialValues = {
    locale: "",
    version: version,
  };

  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_VERSION_LOCALE_MUTATION}
      refetchQueries={[READ_VERSION_LANGUAGES_QUERY_NAME]}
      initialValues={initialValues}
      validationSchema={addLocaleValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Add locale"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Locale information" />
      <FormTextField name="locale" label="Locale" />
    </DialogFormWithMutation>
  );
};

AddLocaleDialog.propTypes = {
  version: PropTypes.string,
};

export default AddLocaleDialog;
